import React from "react";

import styled from "styled-components";

import { ReactComponent as Chat } from "assets/icons/chatBotIcon.svg";

type Props = {
  style?: React.CSSProperties;
};

export const ChatIcon = ({ style }: Props) => {
  return (
    <Container>
      <Icon style={style} />
    </Container>
  );
};

const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: ${({ theme }) => theme.palette.purpleDark};
  padding: 10px;
  border-radius: 50%;
`;
const Icon = styled(Chat)``;
